import GeneratedContactServiceApi from "./generated/GeneratedContactServiceApi"

class ContactServiceApi extends GeneratedContactServiceApi {

}

export const contactServiceApi = new ContactServiceApi()
